import { z } from '@/utils/zod'

export const ScopeNameSchema = z
    .string()
    .min(1)
    .max(64)
    .regex(/^[a-zA-Z0-9:_-]+$/)

export type ScopeName = z.infer<typeof ScopeNameSchema>
